export const handelOpenModalEditDateTime = () => ({
    type: 'OPEN_MODAL_EDIT_DATE_TIME'
});
export const handelCloseModalEditDateTime = () => ({
    type: 'CLOSE_MODAL_EDIT_DATE_TIME'
});
export const handelToggleLoaderModal = (status) => ({
    type: 'TOGGLE_LOADER_MODAL_EDIT_ORDER_DELIVERY_DATE_TIME', status
});

